import { render } from "./Show.vue?vue&type=template&id=de391d9a&scoped=true&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=de391d9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-de391d9a"

export default script